import {GetSpecialtiesSubSpecialtiesDentalGuide} from 'domain/usecases';
import {RemoteGetSpecialtiesSubSpecialtiesDentalGuide} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {GuideFlowEndpoints} from 'main/factories/usecases/endpoints';

export const makeGetSpecialtiesSubSpecialtiesDentalGuide =
	(): GetSpecialtiesSubSpecialtiesDentalGuide =>
		new RemoteGetSpecialtiesSubSpecialtiesDentalGuide(
			makeBFFApiUrl(GuideFlowEndpoints.odontoGuideSpecialties),
			makeAuthorizeHttpClientDecorator(),
		);
